import { render, staticRenderFns } from "./WatchTogetherView.vue?vue&type=template&id=5aa91e74&scoped=true&"
import script from "./WatchTogetherView.vue?vue&type=script&lang=js&"
export * from "./WatchTogetherView.vue?vue&type=script&lang=js&"
import style0 from "./WatchTogetherView.vue?vue&type=style&index=0&id=5aa91e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa91e74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aa91e74')) {
      api.createRecord('5aa91e74', component.options)
    } else {
      api.reload('5aa91e74', component.options)
    }
    module.hot.accept("./WatchTogetherView.vue?vue&type=template&id=5aa91e74&scoped=true&", function () {
      api.rerender('5aa91e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/watchTogether/ongoing/WatchTogetherView.vue"
export default component.exports